/*
 * Format app type for display.
 *
 * Usage:
 *   type | formatAppType
 * Example:
 *   {{ 'APP_TYPE_APP' | formatAppType }}
 *   formats to: 'Product'

*/
import { Pipe, PipeTransform } from '@angular/core';
import { AppType } from '@vendasta/marketplace-apps';

@Pipe({ standalone: true, name: 'formatAppType' })
export class FormatAppTypePipe implements PipeTransform {
  transform(appType: AppType): string {
    return getAppTypeString(appType);
  }
}

function getAppTypeString(appType: AppType): string {
  switch (appType) {
    case AppType.APP_TYPE_APP:
      return 'Product';
    case AppType.APP_TYPE_ADDON:
      return 'Add-on';
    default:
      return 'Not specified';
  }
}
